<template>
  <div class="base-page" :style="fieldStyle" :class="[screenType, getPosition == 'LEFT' && screenType != 'smartphone' ? 'right' : 'left']">
    <div class="base-page-content">
      <div v-if="!isApp" class="redirect mt-4" align-center :style="getToolbarStyle" @click="back">
        <v-icon class="ml-2" large dark :style="getArrowStyle">west</v-icon>
        <div>
          <span v-if="screenType === 'smartphone'" class="text" :style="getReturnBtnStyle">&nbsp;</span>
          <span v-else class="text" :style="getArrowStyle">{{ btnText }}</span>
        </div>
      </div>
      <div class="page-content-container">
        <slot></slot>
      </div>
    </div>
    <div ref="image" class="base-page-image">
      <img :src="getSideImage" @load="imageLoad" />
    </div>
  </div>
</template>

<script>
import { resizeImageHeight } from '@/helpers/resize-image-height'
import { screenTypeMixin } from '@/mixins/screen-type'
export default {
  mixins: [screenTypeMixin],
  props: {
    manualRedirect: {
      type: Boolean,
      default: false
    },
    redirectTo: {
      type: String,
      default: ''
    }
  },
  computed: {
    btnText() {
      return this.$route.name === 'nova-senha' ? 'Voltar para o início' : 'VOLTAR'
    },
    isApp() {
      return this.$store.getters.IS_APP
    },
    getAssets() {
      return this.$store.getters.GET_ASSETS
    },
    getPosition() {
      return this.$store.getters.GET_POSITION
    },
    fieldStyle() {
      return {
        '--button-background-color': [this.getAssets.colors.form.buttonBackground],
        '--button-text-color': [this.getAssets.colors.form.buttonFont]
      }
    },
    getSideImage() {
      return this.getAssets.images.form[this.screenType]
    },
    getLogo() {
      return this.getAssets.images.form.smartphone
    },
    getReturnBtnStyle() {
      // if (this.screenType === 'smartphone' && this.getLogo === '') {
      //   return {
      //     color: this.getAssets.colors.primaryButtonFont,
      //     backgroundColor: this.getAssets.colors.primaryButtonBackground
      //   }
      // }
      return {
        color: this.getContrast === 'light' ? '#FFF' : 'rgba(0, 0, 0, 0.87)',
        background: `url(${this.getLogo}) center right 20px no-repeat`
      }
    },
    getContrast() {
      return this.$contrastHex(this.getAssets.colors.form.toolbar)
    },
    getArrowStyle() {
      if (this.screenType === 'smartphone' && this.getLogo !== '')
        return { color: this.getContrast === 'dark' ? 'rgba(0, 0, 0, 0.87)' : this.getAssets.colors.form.toolbar }
      return { color: this.getContrast === 'light' ? '#FFF' : 'rgba(0, 0, 0, 0.87)' }
    },
    getToolbarStyle() {
      const width = this.$route.name === 'nova-senha' ? '260px' : '200px'
      if (this.screenType === 'smartphone' && this.getLogo !== '') return { backgroundColor: '#FFF' }
      return { backgroundColor: this.getAssets.colors.form.toolbar, width }
    },
    isSmsRecover() {
      return this.$store.getters.IS_RECOVER_SMS
    },
    getSocialMedia() {
      const socialMedia = Object.entries(this.$store.getters.SOCIAL_MEDIA)
      return socialMedia.filter(media => media[1] && media[0] !== 'whatsapp')
    },
    getWhatsapp() {
      return this.$store.getters.SOCIAL_MEDIA.whatsapp ? this.$store.getters.SOCIAL_MEDIA.whatsapp.find(number => number.show_in_hotsite) : {}
    },
    hasSocialMedia() {
      return !!(this.getSocialMedia.length || (this.getWhatsapp && this.getWhatsapp.link))
    }
  },
  watch: {
    screenType(newVal, oldVal) {
      if (newVal !== oldVal) {
        const time = setTimeout(() => {
          this.resizeImage()
          clearTimeout(time)
        }, 100)
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.resizeImage)
    window.addEventListener('scroll', () => resizeImageHeight('.base-page-image', '.base-page-content', this.hasSocialMedia))
    window.addEventListener('orientationchange', this.resizeImage)

    this.resizeImage()
    resizeImageHeight('.base-page-image', '.base-page-content')
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeImage)
    window.removeEventListener('scroll', () => resizeImageHeight('.base-page-image', '.base-page-content', this.hasSocialMedia))
  },
  methods: {
    back() {
      if (this.manualRedirect) {
        this.$emit('go-back')
        return
      }
      if (this.redirectTo) {
        this.$router.push({ name: this.redirectTo })
        return
      }
      this.$router.go(-1)
    },
    imageLoad() {
      this.resizeImage()
    },
    resizeImage() {
      if (!this.$refs.image) return
      if (!this.$vuetify.breakpoint.xs) {
        this.$refs.image.style.height = `${window.innerHeight}px`
      } else {
        this.$refs.image.style.height = `100%`
      }
      resizeImageHeight('.base-page-image', '.base-page-content', this.hasSocialMedia)
    }
  }
}
</script>

<style lang="scss">
$phone-size: 599px;
$tablet-size: 960px;

.base-page {
  padding: 40px 0;
  $self: &;
  display: flex;
  width: 100%;
  height: 100%;
  &.right {
    justify-content: flex-end;
    #{$self}-image {
      left: 0;
      background-position: left center !important;
      background-size: auto 100% !important;
    }
    &-content {
      display: flex;
      flex-direction: column;
      width: 50%;
      .form {
        padding: 40px 60px 0 0;
      }
    }
  }
  &-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    .page-content-container {
      margin: auto;
      padding: 0 20px;
      height: 100%;
      display: flex;
      align-items: center;
    }
    .form {
      padding: 40px 20px 0;
    }
    .page-title {
      font-family: Roboto !important;
      font-style: normal !important;
      font-weight: normal !important;
      font-size: 32px !important;
      line-height: 37px;
      margin-bottom: 25px;
    }
  }
  &-image {
    display: flex;
    max-width: 600px;
    position: fixed;
    top: 0;
    right: 0;
    background-size: auto 100% !important;

    & image {
      display: block;
      width: 100%;
    }
  }
  &.desktop {
    .redirect {
      .v-icon.v-icon {
        margin-left: 30px !important;
      }
    }
    .col-100 {
      clear: both;
      width: calc(100% - 20px);
      margin: 0 10px;
    }
    .col-70 {
      float: right;
      width: calc(85% - 20px);
      margin: 0 10px;
      .v-input {
      }
    }
    .col-50 {
      float: left;
      width: calc(50% - 20px);
      margin: 0 10px;
      .v-input {
      }
    }
    .col-30 {
      float: left;
      width: calc(15% - 20px);
      margin: 0 10px;
      .v-input {
      }
    }
    .page-title {
      margin-left: 10px;
    }
  }
  &.smartphone,
  &.tablet {
    .col-100 {
      clear: left;
    }
    .col-50 {
      width: 100%;
      margin-right: 0;
      .v-input {
      }
    }
    .v-input--selection-controls .v-input__slot > .v-label,
    .v-input--selection-controls .v-radio > .v-label {
      display: inline;
    }
  }
  &.smartphone {
    width: 100%;
    padding: 82px 0 0;
    #{$self}-content {
      width: 100%;
    }
    #{$self}-image {
      display: none;
    }
  }
  &.smartphone {
    width: 100%;
    padding: 82px 0 0;
    #{$self}-content {
      width: 100%;
    }
    #{$self}-image {
      display: none;
    }
  }
  .redirect {
    z-index: 5;
    cursor: pointer;
    user-select: none;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
    height: 67px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0 5px 5px 0;
    .text {
      font-family: 'Roboto', medium;
      font-size: 18px;
      text-align: right;
      width: 100%;
      padding-right: 20px;
    }
    div {
      display: flex;
      width: inherit;
    }
    @media screen and (max-width: $phone-size) {
      height: 82px;
      margin-top: 0 !important;
      border-radius: 0;
      position: fixed;
      top: 0;
      width: 100%;
      .text {
        height: 82px;
        width: 100%;
        background-size: contain !important;
      }
      .v-icon.v-icon {
        margin-left: 20px !important;
      }
    }
    @media screen and (max-width: $tablet-size) {
      .redirect {
        .v-icon.v-icon {
          margin-left: 20px !important;
        }
      }
    }
    @media screen and (min-width: $tablet-size) {
      .redirect {
        .v-icon.v-icon {
          margin-left: 30px !important;
        }
      }
    }
  }
}
@media screen and (max-width: 1024px) and (min-width: 600px) {
  .base-page {
    &-image {
      max-width: 305px;
    }
  }
}
.terms-check {
  clear: both;
  float: none;
  margin: 0 10px;
}
.col-50,
.col-100 {
  padding: 0 0 15px !important;
  .v-input__slot {
    &:first-child {
      margin-top: 0;
    }
  }
}
.ml-1 {
  text-decoration: underline;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0;
  padding: 5px 0 0 5px !important;
}
.block {
  .v-input__control {
    .v-text-field__details {
      display: block !important;
    }
  }
}
.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state):not(.v-input--is-disabled)
  > .v-input__control
  > .v-input__slot:hover
  fieldset,
.v-application .primary--text {
  border-color: var(--button-background-color) !important;
  caret-color: var(--button-background-color) !important;
}
.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state):not(.v-input--is-disabled)
  > .v-input__control
  > .v-input__slot:hover
  label,
.v-application .primary--text,
a {
  color: var(--button-background-color) !important;
}
</style>
